import Constants from './constants';
import router from "../../router";

const initialBreadcrumb = { fullPath: '/dashboard', title: 'Главная' };

const state = {
    isMobileMenuVisible: false,
    route: undefined,
    breadcrumbs: [ initialBreadcrumb ],
    _contextMenuContainerBoundaries: null
};

const getters = {
    getIsMobileMenuVisible: (s) => s.isMobileMenuVisible,
    getRoute: (s) => s.route,
    getBreadcrumbs: (s) => s.breadcrumbs,
    contextMenuContainerBoundaries: (s) => s._contextMenuContainerBoundaries
};

const mutations = {
    [Constants.UIStates.UI_MOBILE_MENU_SHOWN]: (state) => {
        state.isMobileMenuVisible = true;
    },
    [Constants.UIStates.UI_MOBILE_MENU_HIDDEN]: (state) => {
        state.isMobileMenuVisible = false;
    },
    [Constants.UIStates.UI_ROUTE_CHANGED]: (state, value) => {
        state.route = value;
    },
    [Constants.UIStates.UI_BREADCRUMB_PUSHED]: (state, value) => {
        state.breadcrumbs.push(value);
    },
    [Constants.UIStates.UI_BREADCRUMB_POPPED]: (state) => {
        state.breadcrumbs.pop();
    },
    [Constants.UIStates.UI_BREADCRUMBS_CLEANED]: (state) => {
        state.breadcrumbs = [ initialBreadcrumb ];
    },
    [Constants.UIStates.UI_CONTEXT_MENU_CONTAINER_BOUNDARIES]: (state, value) => {
        state._contextMenuContainerBoundaries = value
    }
};

const actions = {
    [Constants.UIActions.UI_HIDE_MOBILE_MENU]: ({commit}) => {
        commit(Constants.UIStates.UI_MOBILE_MENU_HIDDEN);
    },
    [Constants.UIActions.UI_SHOW_MOBILE_MENU]: ({commit}) => {
        commit(Constants.UIStates.UI_MOBILE_MENU_SHOWN);
    },
    [Constants.UIActions.UI_CHANGE_ROUTE]: ({commit}, payload) => {
        commit(Constants.UIStates.UI_ROUTE_CHANGED, payload.route);
    },
    [Constants.UIActions.UI_PUSH_BREADCRUMB]: ({commit}, payload) => {
        commit(Constants.UIStates.UI_BREADCRUMB_PUSHED, payload);
    },
    [Constants.UIActions.UI_POP_BREADCRUMB]: ({commit}) => {
        commit(Constants.UIStates.UI_BREADCRUMB_POPPED);
    },
    [Constants.UIActions.UI_CLEAN_BREADCRUMBS]: ({commit}) => {
        commit(Constants.UIStates.UI_BREADCRUMBS_CLEANED);
    },
    [Constants.UIActions.UI_CONTEXT_MENU_CONTAINER_SET_BOUNDARIES]: ({commit}, payload) => {
        commit(Constants.UIStates.UI_CONTEXT_MENU_CONTAINER_BOUNDARIES, payload.boundaries)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}